import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import API from '../../services/API';
import { Fab, IconButton } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import PopupDB from './PopupDB';
import {useSnackbar} from 'notistack';




export default function LignesCommandeFournisseur(){
    const [lignesCommandeFournisseur, setLignesCommandeFournisseur] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false)
    const [dataChange, setDataChange] = useState(true)
    const [actionPopup, setActionPopup] = useState("Créer")
    const [modifyingData, setModifyingData] = useState({})

    const { enqueueSnackbar } = useSnackbar();

    const columns = [
        {field: 'actions', headerName: 'Actions', sortable: false,
            renderCell: (params) => {
              const onClickModify = (e) => {
                e.stopPropagation(); // don't select this row after clicking
                handleModify(params.row)
              };
              const onClickDelete = (e) => {
                e.stopPropagation(); // don't select this row after clicking
                let conf = window.confirm("Etes-vous sûr de vouloir supprimer cette ligne de commande fournisseur ? Pas de retour en arrière ...")
                if(conf){
                    handleDelete(params.row)
                }
              };
        
              return(
                  <>
                      <IconButton color="primary" component="span" onClick={onClickModify}><Edit /></IconButton>
                      <IconButton color="primary" component="span" onClick={onClickDelete}><Delete /></IconButton>
                  </>
              )
            },
        },
        { field: 'id'},
        { field: 'Fournisseur_id', headerName: 'ID Fournisseur'},
        { field: 'Produit_id', headerName: 'ID Produit'},
        { field: 'date_commande', headerName: 'Date de commande'},
        { field: 'quantite_commandee', headerName: 'Quantité commandée'},
        { field: 'quantite_livree', headerName: 'Quantité livrée'},
        { field: 'quantite_refusee', headerName: 'Quantité refusée'},
        { field: 'date_reception', headerName: 'Date de réception'}
    ];

    useEffect(()=>{
        if(!dataChange) return
        API('GET','ligne_commande_fournisseur')
        .then(res=>setLignesCommandeFournisseur(res.json))
        setDataChange(false)
    },[dataChange])

    const handleAdd = ()=>{
        setActionPopup("Créer")
        setModifyingData({})
        setPopupOpen(true)
    }

    const handleModify = (data)=>{
        setActionPopup("Modifier")
        setModifyingData(data)
        setPopupOpen(true)
    }
    const handleDelete = (data)=>{
        API("DELETE","ligne_commande_fournisseur",{id:data.id})
        .then(res=>{
            if(!res.ok){//ERREUR
                enqueueSnackbar("Erreur lors de la suppression : "+res.json.message,{variant: "error"})
            }else{
                enqueueSnackbar("Suppression réussie",{variant: "success"})
            }
            setDataChange(true)
        })
    }

    return (
        <>
            <DataGrid
                rows={lignesCommandeFournisseur}
                columns={columns}
                disableSelectionOnClick 
                autoHeight
            />
            <Fab color="primary" aria-label="Add" sx={{position: "fixed", bottom: "10px", right: "10px"}} onClick={handleAdd}>
                <Add />
            </Fab>
            <PopupDB action={actionPopup} data={modifyingData} extraData={[]}  table="ligne_commande_fournisseur" open={popupOpen} setOpen={setPopupOpen} setDataChange={setDataChange}/>
        </>
    )
}